import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PrivateLocationsForPP } from "../../domain/models";
import { LocationsRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetPrivateLocationByMlsIdUsecase implements UseCase<string, PrivateLocationsForPP> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(mlsId: string): Observable<PrivateLocationsForPP> {
    return this.locationRepository.getPrivateLocationByMlsId(mlsId);
  }
}
